import axios from "axios";

const TOKEN_KEY = "hp_session_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

// Set up axios interceptor to attach token to all requests
axios.interceptors.request.use((config) => {
  // Do not overwrite an Authorization header that was set explicitly on the request
  // (e.g. the admin dashboard passes its own admin token via headers).
  const hasExplicitAuth = !!(config.headers && (config.headers.Authorization || config.headers.authorization));
  if (hasExplicitAuth) {
    return config;
  }
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
